<template>
  <div class="body-wrapper">
    <div class="header">
      <h1>
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
        </transition>
        Projekti
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="badge--mod fas fa-clipboard-list"></i>
        </transition>
      </h1>
      <!-- <h2>{{ communityType }}</h2> -->
    </div>
    <div class="body-wrapper table-poll">
      <div class="table-wrapper">
        <spinner
          class="spinner"
          line-fg-color="#00796b"
          :size="100"
          :line-size="6"
          v-if="loading"
        ></spinner>
        <div v-if="!loading">
          <button
            @click="showModal('ModalContentAddNewProject')"
            class="btn btn-filter"
          >
            Novi projekat
          </button>
          <i
            v-if="filterActive"
            class="fas fa-times filter-icon-out"
            @click="refreshTableAndFilterDropdown"
          ></i>
          <div class="filter-search">
            <div
              ref="filterDropdown"
              class="dropdown"
              :class="{ show: dropdownActive }"
            >
              <button
                @click="openFilter"
                class="btn btn-secondary btn-filter"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :class="{ 'red-filter': filterActive }"
              >
                Filter
              </button>

              <div
                class="dropdown-menu"
                :class="{ show: dropdownActive }"
                aria-labelledby="dropdownMenuButton"
              >
                <div class="checkboxes">
                  <div class="status-filter">
                    <h6>Status</h6>
                    <div class="options status">
                      <template>
                        <div class="option-holder" key="1">
                          <input
                            type="checkbox"
                            name="private"
                            value="1"
                            v-model="statusFilter.done"
                          />
                          <label>Završen</label>
                        </div>
                      </template>
                      <template>
                        <div class="option-holder" key="2">
                          <input
                            type="checkbox"
                            name="private"
                            value="1"
                            v-model="statusFilter.inProgress"
                          />
                          <label>U toku</label>
                        </div>
                      </template>
                    </div>
                  </div>
                  <hr />
                  <div class="status-filter">
                    <h6>Tip</h6>
                    <div class="options status">
                      <template>
                        <div class="option-holder" key="4">
                          <input
                            type="checkbox"
                            name="private"
                            value="1"
                            v-model="typeFilter.permanent"
                          />
                          <label>Trajan</label>
                        </div>
                      </template>
                      <template>
                        <div class="option-holder" key="5">
                          <input
                            type="checkbox"
                            name="private"
                            value="1"
                            v-model="typeFilter.temporary"
                          />
                          <label>Privremen</label>
                        </div>
                      </template>
                    </div>
                  </div>
                  <hr />
                </div>
                <div class="footer-filter">
                  <button
                    @click="setFilterQueryParams"
                    class="btn btn-go left"
                    type="button"
                  >
                    Primeni filter
                  </button>
                  <button
                    @click="refreshTableAndFilterDropdown"
                    class="btn btn-secondary btn-go"
                    type="button"
                  >
                    Resetuj filter
                  </button>
                </div>
              </div>
            </div>
          </div>
          <data-table
            :columns="table.tableColumns"
            :tableData="tableData"
            :options="table.tableOptions"
            :slotProjectType="'projectType'"
            :slotProjectCompleted="'completedNum'"
            :slotNameProjects="'action'"
            @row-click="rowClick"
          ></data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table';
import { mapMutations, mapState, mapActions } from 'vuex';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      table: {
        tableColumns: [
          'title',
          'description',
          'projectType',
          'completedNum',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            title: 'Naziv',
            description: 'Opis',
            projectType: 'Tip',
            completedNum: 'Završeno',
            action: 'Akcije'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje projekti'
          },
          sortable: ['name']
        }
      },
      filterActive: false,
      dropdownActive: false,
      search: '',
      statusFilter: {
        done: false,
        inProgress: false
      },
      typeFilter: {
        permanent: false,
        temporary: false
      }
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['modalVisible']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  async created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.cardOpened();
    //loading data to table
    let data = await this.getAllProjects();
    console.log(data);
    const routeParams = this.$route.query;
    if (routeParams.done) {
      this.statusFilter.done = true;
      if (!routeParams.inProgress) {
        data = data.filter(
          c =>
            Number(c.numberOfClosedTickets) ==
              Number(c.numberOfCommunityProjects) &&
            Number(c.numberOfCommunityProjects) > 0
        );
      }
    }
    if (routeParams.inProgress) {
      this.statusFilter.inProgress = true;
      if (!routeParams.done) {
        data = data.filter(
          c =>
            Number(c.numberOfClosedTickets) !=
            Number(c.numberOfCommunityProjects)
        );
      }
    }
    if (routeParams.temporary) {
      this.typeFilter.temporary = true;
      if (!routeParams.permanent) {
        data = data.filter(c => c.type == 'TEMPORARY');
      }
    }
    if (routeParams.permanent) {
      this.typeFilter.permanent = true;
      if (!routeParams.temporary) {
        data = data.filter(c => c.type == 'PERMANENT');
      }
    }
    this.setTableData(data);
  },
  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    this.setTableBadge('');
  },
  methods: {
    ...mapMutations(['cardOpened', 'loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['showModal', 'showModalWider']),
    ...mapMutations('table', [
      'setTableBadge',
      'unsetTableData',
      'setTableData'
    ]),
    ...mapActions('table', ['getAllProjects']),

    back() {
      this.$router.back();
    },
    rowClick(data) {
      this.$router.push({
        name: 'projectDetails',
        params: {
          projectId: data.row.id
        }
      });
    },
    refreshTableAndFilterDropdown() {
      this.$router.replace({
        name: 'projects'
      });
      this.$router.go();
    },
    setFilterQueryParams() {
      const params = {};
      if (this.statusFilter.done) {
        params.done = true;
      }
      if (this.statusFilter.inProgress) {
        params.inProgress = true;
      }
      if (this.typeFilter.temporary) {
        params.temporary = true;
      }
      if (this.typeFilter.permanent) {
        params.permanent = true;
      }

      this.$router.replace({
        name: 'projects',
        query: params
      });
      this.$router.go();
    },
    openFilter() {
      this.dropdownActive = !this.dropdownActive;
      if (this.dropdownActive) {
        document.addEventListener('click', this.closeFilter);
      } else {
        document.removeEventListener('click', this.closeFilter);
      }
    },
    closeFilter(e) {
      if (!this.$refs.filterDropdown.contains(e.target)) {
        this.dropdownActive = false;
        document.removeEventListener('click', this.closeFilter);
      }
    },
    searching() {}
  }
};
</script>
<style lang="scss" scoped>
.btn-go {
  margin-top: 5px;
  position: absolute;
  right: 0;
  &.left {
    left: 0;
    color: white;
    background: var(--primary-color);
  }
}
.footer-filter {
  position: relative;
  display: flex;
  height: 35px;
}
.dropdown {
  position: absolute;
  right: 205px;
  width: 90px;
}

.dropdown-menu {
  width: 300px;
  padding: 1em 1em;
  border: 1px solid var(--primary-color);
  overflow: hidden;
}

.dropdown-menu.show {
  top: 38px;
}
.checkboxes label {
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
  margin-left: 3px;
  margin-bottom: 0;
}
.checkboxes hr {
  border-top: 1px solid var(--primary-color-lighten);
}
.contractor-filter hr {
  border-top: 1px solid var(--primary-color-lighten);
}
.checkboxes .options {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.checkboxes .options.status {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.checkboxes .option-holder {
  // display: inline-block;
  margin-right: 6px;
}
.btn-filter {
  background: var(--primary-color);
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.fas.fa-times.filter-icon-out {
  position: absolute;
  padding-top: 10px;
  right: 350px;
}
#selecCategory {
  position: absolute;
  right: 230px;
  z-index: 10;
  width: 180px;
  text-align: center;
  font-size: 1rem;
}
.body-wrapper {
  display: block;
  padding: 10px;

  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}

.table-wrapper {
  position: relative;
}

.VuePagination {
  display: none;
}

h1,
h2 {
  text-align: center;
}

h1 {
  padding-top: 25px;
  position: relative;
}

h2 {
  color: #636363;
  padding-bottom: 20px;
}

i {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

i:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.spinner {
  padding-top: 10%;
}

.btn:focus {
  box-shadow: none;
}
</style>
